function formatRatingScore(rating) {
  const rounded = Math.round(rating * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

function getReviewRatingData() {
  const dataEl = document.getElementById("product-review-rating-data");

  if (!dataEl) return null;

  try {
    const data = JSON.parse(dataEl.textContent);

    if (!data?.rating || !data?.count) return null;

    return data;
  } catch {
    return null;
  }
}

function injectWidgetSummaryScore(rating) {
  const summaryInner = document.querySelector(".jdgm-rev-widg__summary-inner");

  if (!summaryInner || summaryInner.querySelector(".jdgm-custom-rating-score")) {
    return Boolean(summaryInner?.querySelector(".jdgm-custom-rating-score"));
  }

  const stars = summaryInner.querySelector(".jdgm-rev-widg__summary-stars");

  if (!stars) return false;

  const score = document.createElement("span");
  score.className = "jdgm-custom-rating-score";
  score.textContent = `${formatRatingScore(rating)}/5`;

  const row = document.createElement("div");
  row.className = "jdgm-custom-rating-summary-row";
  summaryInner.insertBefore(row, stars);
  row.appendChild(score);
  row.appendChild(stars);

  return true;
}

function initJudgeMeReviews() {
  const data = getReviewRatingData();

  if (!data) return;

  if (injectWidgetSummaryScore(data.rating)) return;

  const widget = document.getElementById("judgeme_product_reviews");

  if (!widget) return;

  const observer = new MutationObserver(() => {
    if (injectWidgetSummaryScore(data.rating)) {
      observer.disconnect();
    }
  });

  observer.observe(widget, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initJudgeMeReviews);
} else {
  initJudgeMeReviews();
}
